<template>
  <div class="artwork-item" data-packed>
    <div class="pic" :style="`height:${240/data.imageWidth*data.imageHeight}px`">
      <router-link :to="`/artwork/${data.id}`" target="_blank">
        <img :data-src="data.imageUrl | imageUrl" :src="data.imageUrl | imageUrl('?imageView2/2/w/480')" />
      </router-link>
    </div>
    <div class="content">
      <h2 class="name" v-if="data.name">
        <router-link :to="`/artwork/${data.id}`" target="_blank">{{data.name}}</router-link>
      </h2>
      <p v-if="data.author">{{data.author}}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ArtworkItem',
  props: { data: Object },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    init() {
      this.$emit('update')
    }
  }
}
</script>
<style>
.artwork-item {
  width: 240px;
  padding-bottom: 8px;
}
.artwork-item .pic {
  position: relative;
  width: 100%;
  margin-bottom: 10px;
  border-radius: 4px;
  overflow: hidden;
  background-color: #e9ebf2;
}
.artwork-item .pic img {
  width: 100%;
}
.artwork-item:hover .content .name {
  color: #1e88f5;
}
.artwork-item .content {
  font-size: 14px;
  line-height: 20px;
  color: #666;
}
.artwork-item .content .name {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: normal;
  line-height: 20px;
  color: #333;
}
.artwork-item .content p {
  font-size: 14px;
  line-height: 17px;
  color: #666;
  margin-top: 6px;
}
</style>
